import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { PerformanceTrackerEffect } from "./effect";
import { PerformanceTrackerReducer } from "./reducer";

@NgModule({
    imports: [
        EffectsModule.forFeature([PerformanceTrackerEffect]),
        StoreModule.forFeature('performanceTracker', PerformanceTrackerReducer)
    ]
})

export class PerformanceTrackerStoreModule { }

export const performanceTrackerList = (store: any) => store && store.performanceTracker && store.performanceTracker.performanceTrackerList;
export const performanceTrackerByFieldList = (store: any) => store && store.performanceTracker && store.performanceTracker.performanceTrackerByFieldList;
export const performanceTrackerById = (store: any) => store && store.performanceTracker && store.performanceTracker.performanceTrackerById;
export const savePerformanceTrackerResp = (store: any) => store && store.performanceTracker && store.performanceTracker.savePerformanceTrackerResp;
export const deletePerformanceTrackerResp = (store: any) => store && store.performanceTracker && store.performanceTracker.deletePerformanceTrackerResp;
